/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Saving_ChangesInputs */

const en_task_saving_changes = /** @type {(inputs: Task_Saving_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const pt_br2_task_saving_changes = /** @type {(inputs: Task_Saving_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvando…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Task_Saving_ChangesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_saving_changes = /** @type {((inputs?: Task_Saving_ChangesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Saving_ChangesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_saving_changes(inputs)
	return pt_br2_task_saving_changes(inputs)
});